export {
    default as IndicatorWithoutArrow,
    IIndicatorWithoutArrowProps,
    TIndicatorWithoutArrowColor,
} from './indicator-without-arrow';
